export function formatBytes(bytes: number, digits = 1): string {
  if (!Number.isFinite(bytes)) return "–";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit++;
  }
  return `${value.toFixed(unit === 0 ? 0 : digits)} ${units[unit]}`;
}

export function formatCount(n: number): string {
  return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

/** Metres with a sensible number of decimals for the magnitude shown. */
export function formatMetres(m: number): string {
  const abs = Math.abs(m);
  const digits = abs >= 1000 ? 0 : abs >= 10 ? 2 : 3;
  return `${m.toFixed(digits)} m`;
}

/** Square metres with a sensible number of decimals for the magnitude shown. */
export function formatArea(m2: number): string {
  const abs = Math.abs(m2);
  const digits = abs >= 1000 ? 0 : abs >= 10 ? 1 : 2;
  return `${m2.toFixed(digits)} m²`;
}

/** Cubic metres with a sensible number of decimals for the magnitude shown. */
export function formatVolume(m3: number): string {
  const abs = Math.abs(m3);
  const digits = abs >= 1000 ? 0 : abs >= 10 ? 1 : 2;
  return `${m3.toFixed(digits)} m³`;
}

export function formatCoord(v: number): string {
  return v.toLocaleString("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
    useGrouping: false,
  });
}

export function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === "string") return error;
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
}
